import classNames from 'classnames';
import React from 'react';
import alertIcon from '../../icons/non-prefilled/16x16/alert.svg';
import SVGIcon from '../SVGIcon';
import Tooltip from '../Tooltip';
import * as styles from './TextualControl.module.scss';

export interface TextualControlProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  append?: React.ReactNode;
  error?: string;
  label?: React.ReactNode;
  prepend?: React.ReactNode;
  inputRef?: React.Ref<HTMLInputElement>;
  noMinWidth?: boolean;
}

const TextualControl = ({
  append,
  error,
  label,
  prepend,
  inputRef,
  noMinWidth,
  ...inputProps
}: TextualControlProps) => (
  <label className={error && styles.error}>
    {!!label && <div className={styles.label}>{label}</div>}
    <div
      className={classNames(styles.inputContainer, {
        [styles.disabled]: inputProps.disabled,
        [styles.noMinWidth]: noMinWidth,
      })}
    >
      {!!prepend && <div className={styles.prepend}>{prepend}</div>}
      <input {...inputProps} ref={inputRef} />
      {!!append && <div className={styles.append}>{append}</div>}
      {error && (
        <div className={styles.errorContainer}>
          <Tooltip
            display="block"
            content={error}
            danger
            offset={14}
            enabledForSmallSize
            trigger="clickOrHover"
          >
            <SVGIcon className={styles.errorIcon}>{alertIcon}</SVGIcon>
          </Tooltip>
        </div>
      )}
    </div>
  </label>
);

export default TextualControl;
